import { useState } from "react";
import { createPortal } from "react-dom";

import { useAppDispatch } from "../../../../../hook/useAppDispatch";

import { setIsCommandLineInterfaceModalOpen } from "../../../../../store/slice/health-monitor/modal";
import { useTranslation } from "react-i18next";

const CommandLineInterface: React.FC = () => {
  const [inputValue, setInputValue] = useState<string>("");
  const [commands, setCommands] = useState<string[]>([]);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setInputValue(e.target.value);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setCommands((prevState) => [...prevState, inputValue]);
      setInputValue("");
    }
  };

  const handleClose = () => {
    dispatch(setIsCommandLineInterfaceModalOpen(false));
  };

  return (
    <>
      {createPortal(
        <div className="overlay_modal">
          <div className="modal_content cli">
            <button onClick={handleClose}>
              {t("healthMonitor.deviceDetails.cliModal.close")}
            </button>
            <div>{t("healthMonitor.deviceDetails.cliModal.title")}</div>
            <ul className="cli_output">
              {commands?.map((command) => (
                <li>{command}</li>
              ))}
            </ul>
            <input
              className="cli_input"
              type="search"
              spellCheck={false}
              value={inputValue || ""}
              onChange={(e) => handleOnChange(e)}
              onKeyDown={(e) => handleOnKeyDown(e)}
              placeholder={t(
                "healthMonitor.deviceDetails.cliModal.placeholder"
              )}
            ></input>
          </div>
        </div>,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        document.getElementById("root_overlay")!
      )}
    </>
  );
};

export default CommandLineInterface;
